export const enum PATCH_ACTIVATION_STATUS {
    "Active" = "Active",
    "Deactivated" = "Deactivated",
    "Incomplete" = "Incomplete",
    "Pending" = "Pending"
}